import { useMemo } from 'react';
import { useMyInfo } from 'shared/src/queries';

export const usePersonalizationDescription = (): string => {
  const { data: myInfo } = useMyInfo();

  return useMemo(() => {
    if (myInfo == null) return '';
    const parts = [
      myInfo.height != null ? `${myInfo.height}cm` : null,
      myInfo.weight != null ? `${myInfo.weight}kg` : null,
      myInfo.skin_tone?.name ?? null,
      myInfo.skin_type?.name ?? null,
    ].filter((v): v is string => v != null);
    return parts.join(' · ');
  }, [myInfo]);
};
